const routes = [
  {
    path: '/partner-categories',
    name: 'partner-categories',
    meta: {
      authRequired: true,
      permission: 'partner.list'
    },
    component: () => import('./Index.vue')
  }
]

export default routes
